import RelatorioFormulario, { ContagemEvidencias, RegistradoPor } from './RelatorioFormulario';

// Consulta das auditorias de Quiosque (Dessert Center).
//
// A TELA está em RelatorioFormulario.js, hoje compartilhada só com a Avaliação
// de Treinamento (ex-TSV; a Auditoria SA saiu em 2026-09-23, DEM-00011 T22) —
// aqui ficam as colunas próprias: quem identifica a visita é o QUIOSQUE (a
// loja sozinha não distingue CK1 de CK4) e o resultado é pontuação (x/19), não
// um status de aprovação — o formulário de papel não define faixa.
// ⚠️ Só a aba HISTÓRICO usa isto desde a T23 — o preenchimento saiu.

const dataBR = (d) => {
  if (!d) return '';
  const dt = new Date(d);
  return Number.isNaN(dt.getTime()) ? String(d) : dt.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
};

const colunasLista = [
  { titulo: 'Quiosque', estilo: { fontWeight: 700 }, render: (v) => v.QUIOSQUE },
  { titulo: 'Loja', render: (v) => v.LOJA },
  { titulo: 'Data', render: (v) => dataBR(v.DATA) },
  { titulo: 'Gerente RDM', estilo: { whiteSpace: 'normal' }, render: (v) => v.GERENTE_RDM || '—' },
  {
    titulo: 'Pontos', alinhamento: 'right', estilo: { fontVariantNumeric: 'tabular-nums', fontWeight: 600 },
    render: (v) => `${v.PONTOS_OBTIDOS}/${v.PONTOS_MAXIMOS}`,
  },
  {
    titulo: '% Atingido', alinhamento: 'right', estilo: { fontVariantNumeric: 'tabular-nums', fontWeight: 600 },
    render: (v) => `${Number(v.PERCENTUAL_TOTAL).toFixed(2)}%`,
  },
  { titulo: 'Evidências', alinhamento: 'center', render: (v) => <ContagemEvidencias qtd={v.QTD_EVIDENCIAS} /> },
  { titulo: 'Registrado por', estilo: { whiteSpace: 'normal' }, render: (v) => <RegistradoPor nome={v.REGISTRADO_POR} /> },
];

// CSV: o cabeçalho e o resultado. O detalhe pergunta a pergunta está no PDF —
// exportá-lo aqui exigiria uma consulta por auditoria (o dado é normalizado).
const colunasCsv = [
  { key: 'QUIOSQUE', label: 'Quiosque' },
  { key: 'LOJA', label: 'Loja' },
  { key: 'DATA', label: 'Data' },
  { key: 'GERENTE_RDM', label: 'Gerente de RDM/Seguimento' },
  { key: 'PONTOS_OBTIDOS', label: 'Pontos obtidos' },
  { key: 'PONTOS_MAXIMOS', label: 'Pontos possíveis' },
  { key: 'PERCENTUAL_TOTAL', label: '% Atingido' },
  { key: 'QTD_EVIDENCIAS', label: 'Evidências (fotos)' },
  { key: 'REGISTRADO_POR', label: 'Registrado por' },
];

function CkQuiosqueRelatorio({ embedded = false }) {
  return (
    <RelatorioFormulario
      api="/api/treinamento/ck-quiosque"
      titulo="Relatório da Auditoria de Quiosque"
      subtitulo="Consulte as auditorias de Dessert Center, abra o relatório em PDF (com as evidências) e exporte os dados."
      colunasLista={colunasLista}
      colunasCsv={colunasCsv}
      // O filtro é por QUIOSQUE: filtrar por loja juntaria CK1 e CK4 na mesma
      // linha de análise, que é justamente o que esta auditoria separa.
      campoFiltroLoja="QUIOSQUE"
      rotuloFiltroLoja="Quiosque"
      embedded={embedded}
    />
  );
}

export default CkQuiosqueRelatorio;
